































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('jobs');

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    computed: {
        jobs() {
            return module.getters('getJobs');
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class TeamMembers extends Vue {}

